"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpClient = _interopRequireDefault(require("../httpClient"));

var _default = {
  getDynamicConfig: function getDynamicConfig(root) {
    return _httpClient.default.get("/gateway/platform/v1/config/".concat(root));
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/dynamicConfig/configService.js
// module id = 4304
// module chunks = 25